export default __webpack_public_path__ + "static/media/default.92215725900a2349aac55408cd7e662e.png";